import React from "react";
import { cn } from "../../../lib/utils";

// Replace TypeScript interface with JSDoc PropType comments
/**
 * @param {Object} props
 * @param {CategoryDto} props.category
 * @param {string} [props.className]
 */

const formatCategoryName = (category) => {
  if (!category) return "";

  // Handle if category is a string
  if (typeof category === "string") {
    return category
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  // Handle if category is an object with name property (CategoryResponse)
  if (category.name) {
    return category.name;
  }

  // Handle if category is an object with categoryName property (CategoryDto)
  if (category.categoryName) {
    return category.categoryName;
  }

  // Handle if category is an object with slug property (fallback)
  if (category.slug) {
    return category.slug
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return "";
};

export const CategoryBadge = ({ category, className }) => {
  return (
    <span
      className={cn(
        "inline-flex items-center px-4 py-1.5 text-xs font-semibold rounded-full shadow-sm transition-all duration-300 hover:scale-105 hover:shadow-md bg-gradient-to-r from-primary/90 via-primary to-primary/80 text-white shadow-primary/20",
        className
      )}
    >
      {formatCategoryName(category)}
    </span>
  );
};
